import type { ZeroBounceResponse } from '~/types/zerobounce';

export const VALID_ZEROBOUNCE_STATUSES = ['valid', 'catch-all'];

export const validateEmail = async (email: string): Promise<ZeroBounceResponse | Error> => {
  try {
    // use useFetch to call /api/email-validation endpoint
    const { data, error } = await useFetch<ZeroBounceResponse>(`/api/email-validation`, {
      method: 'GET',
      query: {
        email,
      },
    });

    if (data.value) {
      return data.value;
    } else if (error.value) {
      throw error.value;
    } else {
      throw new Error('Undhandled error in email validation service');
    }
  } catch (error: any) {
    return error;
  }
};
